import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { Daisy } from "../components/Daisy";
import { useSeo } from "../components/Seo";

export default function Unsubscribe() {
  useSeo({ title: "Odhlášení odběru" });
  const [sp] = useSearchParams();
  const [state, setState] = useState({ busy: true });
  useEffect(() => {
    api.post("/newsletter/unsubscribe", { token: sp.get("t") || "" })
      .then((r) => setState({ ok: true, email: r.data.email }))
      .catch((e) => setState({ error: errMsg(e) }));
  }, [sp]);
  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center" data-testid="unsubscribe-page">
      <Daisy size={70} className="mx-auto animate-wiggle" />
      {state.busy && <p className="mt-6 text-[#6E7565]">Odhlašuji…</p>}
      {state.ok && <><h1 className="h-display mt-6 text-4xl">Odhlášeno</h1><p className="mt-3 text-[#6E7565]" data-testid="unsubscribe-success">Adresa {state.email} už nebude dostávat novinky. Kdykoli se můžete znovu přihlásit v patičce webu.</p></>}
      {state.error && <><h1 className="h-display mt-6 text-4xl">Odkaz nefunguje</h1><p className="mt-3 text-[#6E7565]" data-testid="unsubscribe-error">Odkaz je neplatný nebo vypršel. Napište nám prosím a odhlásíme vás ručně.</p></>}
      <Link to="/" className="btn-sage mt-8" data-testid="unsubscribe-home-btn">Zpět na web</Link>
    </div>
  );
}
